import React from "react";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { RiFeedbackFill } from "react-icons/ri";
import { MdDashboard } from "react-icons/md";

function Sidebar({ isOpen }) {
  const { role } = useSelector((state) => state.auth.user);

  return (
    <aside
      className={`fixed top-0 left-0 z-40 w-64 h-screen pt-14 transition-transform ${
        isOpen ? "translate-x-0" : "-translate-x-full"
      } bg-white border-r border-gray-200 md:translate-x-0 dark:bg-gray-800 dark:border-gray-700`}
      aria-label="Sidenav"
      id="drawer-navigation"
    >
      <div className="overflow-y-auto py-5 px-3 h-full bg-gradient-to-b from-white to-gray-50 dark:from-gray-800 dark:to-gray-900">
        {/* Logo & branding section */}
        {/* <div className="flex items-center justify-center mb-6 pb-4 border-b border-gray-100 dark:border-gray-700">
          <div className="relative w-10 h-10 bg-gradient-to-r from-green-400 to-blue-500 rounded-lg flex items-center justify-center shadow-lg">
            <span className="text-white font-bold text-lg">AI</span>
            <div className="absolute -bottom-1 -right-1 w-4 h-4 bg-green-500 rounded-full border-2 border-white dark:border-gray-800"></div>
          </div>
          <div className="ml-3">
            <h3 className="font-bold text-gray-900 dark:text-white">
              Mena<span className="text-green-500">Devs</span>
            </h3>
            <p className="text-xs text-gray-500 dark:text-gray-400">AI Dashboard</p>
          </div>
        </div> */}

        {/* Main navigation */}
        <div className="px-2">
          <h3 className="text-xs uppercase font-semibold text-gray-500 dark:text-gray-400 mb-2 pl-2">
            Main Navigation
          </h3>
          <ul className="space-y-2">

            {/* ----- Dashboard Link ----- */}
            <li>
              <NavLink to="/dashboard">
                {({ isActive }) => {
                  const containerClasses = `flex items-center p-2 text-base font-medium rounded-lg dark:text-white group relative overflow-hidden ${
                    isActive
                      ? "bg-gradient-to-r from-green-500 to-teal-500 text-white shadow-md"
                      : "hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-800 dark:text-gray-200"
                  }`;

                  const iconContainerClasses = `flex items-center justify-center w-8 h-8 rounded-md ${
                    isActive ? "bg-white/30" : "bg-gray-100 dark:bg-gray-700"
                  }`;

                  const iconClasses = `w-5 h-5 ${
                    isActive
                      ? "text-white"
                      : "text-gray-500 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
                  }`;

                  return (
                    <div className={containerClasses}>
                      <div className="flex items-center w-full">
                        <div className={iconContainerClasses}>
                          <MdDashboard className={iconClasses} />
                        </div>
                        <span className="ml-3 font-medium">Dashboard</span>
                      </div>
                      {isActive && (
                        <span className="absolute right-2 w-2 h-2 rounded-full bg-white"></span>
                      )}
                    </div>
                  );
                }}
              </NavLink>
            </li>

            {/* ----- Users Link (admin only) ----- */}
            {role === "admin" && (
              <li>
                <NavLink to="/users">
                  {({ isActive }) => {
                    const containerClasses = `flex items-center p-2 text-base font-medium rounded-lg dark:text-white group relative overflow-hidden ${
                      isActive
                        ? "bg-gradient-to-r from-green-500 to-teal-500 text-white shadow-md"
                        : "hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-800 dark:text-gray-200"
                    }`;

                    const iconContainerClasses = `flex items-center justify-center w-8 h-8 rounded-md ${
                      isActive ? "bg-white/30" : "bg-gray-100 dark:bg-gray-700"
                    }`;

                    const iconClasses = `w-5 h-5 ${
                      isActive
                        ? "text-white"
                        : "text-gray-500 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
                    }`;

                    return (
                      <div className={containerClasses}>
                        <div className="flex items-center w-full">
                          <div className={iconContainerClasses}>
                            {/* Simple user icon */}
                            <svg
                              aria-hidden="true"
                              className={iconClasses}
                              fill="currentColor"
                              viewBox="0 0 20 20"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M10 10a3 3 0 110-6 3 3 0 010 6zm0 2c-3.313 0-6 2.687-6 6v1h12v-1c0-3.313-2.687-6-6-6z" />
                            </svg>
                          </div>
                          <span className="ml-3 font-medium">Users</span>
                        </div>
                        {isActive && (
                          <span className="absolute right-2 w-2 h-2 rounded-full bg-white"></span>
                        )}
                      </div>
                    );
                  }}
                </NavLink>
              </li>
            )}
          </ul>
        </div>

        {/* Resources section */}
        <div className="mt-6 px-2">
          <div className="relative">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-gray-200 dark:border-gray-700"></div>
            </div>
            <div className="relative flex justify-start">
              <h3 className="text-xs uppercase font-semibold bg-gradient-to-b from-white to-gray-50 dark:from-gray-800 dark:to-gray-900 pr-2 text-gray-500 dark:text-gray-400 pl-2">
                Resources
              </h3>
            </div>
          </div>

          <ul className="mt-4 space-y-2">

            {/* ----- Documents Link ----- */}
            <li>
              <NavLink to="/document">
                {({ isActive }) => {
                  const containerClasses = `flex items-center p-2 text-base font-medium rounded-lg dark:text-white group relative overflow-hidden ${
                    isActive
                      ? "bg-gradient-to-r from-blue-500 to-indigo-500 text-white shadow-md"
                      : "hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-800 dark:text-gray-200"
                  }`;

                  const iconContainerClasses = `flex items-center justify-center w-8 h-8 rounded-md ${
                    isActive ? "bg-white/30" : "bg-gray-100 dark:bg-gray-700"
                  }`;

                  const iconClasses = `w-5 h-5 ${
                    isActive
                      ? "text-white"
                      : "text-gray-500 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
                  }`;

                  return (
                    <div className={containerClasses}>
                      <div className="flex items-center w-full">
                        <div className={iconContainerClasses}>
                          <svg
                            aria-hidden="true"
                            className={iconClasses}
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z"></path>
                            <path
                              fillRule="evenodd"
                              d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z"
                              clipRule="evenodd"
                            ></path>
                          </svg>
                        </div>
                        <span className="ml-3 font-medium">Smile Docs</span>
                      </div>
                      {isActive && (
                        <span className="absolute right-2 w-2 h-2 rounded-full bg-white"></span>
                      )}
                    </div>
                  );
                }}
              </NavLink>
            </li>

            {/* ----- Feedback Link (tasker or reviewer) ----- */}
            {(role === "tasker" || role === "reviewer") && (
              <li>
                <NavLink to="/feedback">
                  {({ isActive }) => {
                    const containerClasses = `flex items-center p-2 text-base font-medium rounded-lg dark:text-white group relative overflow-hidden ${
                      isActive
                        ? "bg-gradient-to-r from-blue-500 to-indigo-500 text-white shadow-md"
                        : "hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-800 dark:text-gray-200"
                    }`;

                    const iconContainerClasses = `flex items-center justify-center w-8 h-8 rounded-md ${
                      isActive ? "bg-white/30" : "bg-gray-100 dark:bg-gray-700"
                    }`;

                    const iconClasses = `w-5 h-5 ${
                      isActive
                        ? "text-white"
                        : "text-gray-500 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
                    }`;

                    return (
                      <div className={containerClasses}>
                        <div className="flex items-center w-full">
                          <div className={iconContainerClasses}>
                            <RiFeedbackFill className={iconClasses} />
                          </div>
                          <span className="ml-3 font-medium">Feedback</span>
                        </div>
                        {isActive && (
                          <span className="absolute right-2 w-2 h-2 rounded-full bg-white"></span>
                        )}
                      </div>
                    );
                  }}
                </NavLink>
              </li>
            )}
          </ul>
        </div>

        {/* Status card */}
        <div className="mt-6 mx-2">
          <div className="p-4 rounded-lg bg-gradient-to-r from-gray-100 to-gray-200 dark:from-gray-700 dark:to-gray-800 shadow-inner">
            <div className="flex items-center">
              <div className="relative">
                <div className="w-10 h-10 rounded-full bg-gradient-to-r from-green-400 to-blue-500 flex items-center justify-center text-white font-bold">
                  {role.charAt(0).toUpperCase()}
                </div>
                <div className="absolute -bottom-0.5 -right-0.5 w-4 h-4 rounded-full bg-green-500 border-2 border-white dark:border-gray-800"></div>
              </div>
              <div className="ml-3">
                <h4 className="font-medium text-gray-800 dark:text-white capitalize">
                  {role}
                </h4>
                <p className="text-xs text-gray-500 dark:text-gray-400">Online</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
}

export default Sidebar;